module.exports = __webpack_public_path__ + "img/fundo_granter.0d68d1f0.jpg";